// import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Main from './main';
import Topbar from './components/topbar';
// import HomeCarousel from './components/homeCarousel';
// import About from './components/about';
// import Services from './components/services';
import Footer from './components/footer';
// import ContactForm from './components/contact';

function App() {
  return (
    <div className='App'>
      <header id="header">
        <Topbar />
      </header>
      <Main />
      <footer id="footer">
        <Footer />
      </footer>
    </div>
  );
}

export default App;
